import { propagateMetrics, type PropagationResult } from '@/domain/metrics/propagation/propagate';
import { aggregateFunnelMetrics, type FunnelAggregateResult } from '@/domain/metrics/aggregation/funnel-metrics';
import type { SimulationGraphInput } from './contracts';

export interface MetricsEngineResult {
  propagation: PropagationResult;
  funnel: FunnelAggregateResult;
}

/**
 * SPEC-009 §60/plan §60 — the single place that calls into the SPEC-008
 * engine. Nothing in `src/domain/simulation` re-implements a formula;
 * everything downstream (scenarios, reverse, bottlenecks, financial view)
 * consumes this function's output.
 */
export function runMetricsEngine(graph: SimulationGraphInput): MetricsEngineResult {
  const propagation = propagateMetrics({ nodes: graph.nodes, edges: graph.edges });
  const funnel = aggregateFunnelMetrics(
    graph.nodes.map((node) => ({
      id: node.id,
      roles: node.roles,
      result: propagation.nodeResults.get(node.id)!,
      includeInFunnelInvestment: node.includeInFunnelInvestment,
    })),
  );
  return { propagation, funnel };
}
